let dd = require('ES/lib/dd');
let radio = require('ES/lib/radio');
let Modal = require('ES/widgets/Modal');
let Constants = require('../../../../../../utils/Constants');
let AuthedUserSession = require('../../../../../../utils/AuthedUserSession');

module.exports = dd.createClass({
	componentWillMount(){
		let {service} = this.props;
		radio("BugHunter_logit").broadcast({not_built_yet: true, feature: service + " contact grabber", username: AuthedUserSession.MY_USERNAME});
	},
	render(){
		let {service, onClose} = this.props;

		return Modal({
				title: 'Coming soon: ' + Constants.GRAB_SERVICES[service],
				buttons: [],
				onClose: onClose
			},
			dd.div({className: 'row'},
				dd.div({className: 'col-sm-3 text-center text-muted'},
					dd.i({
						className: 'fa fa-wrench',
						style: {fontSize: 100}
					})
				),
				dd.div({className: 'col-sm-9'},
					dd.p({style: {fontSize: 18}},
						"Coming soon!"
					),
					dd.p({style: {fontSize: 14}},
						Constants.GRAB_SERVICES[service],
						" has not yet been integrated for myevents."
					)
				)
			),
			dd.div({className: 'text-center'},
				dd.button({className: "btn btn-primary", onClick: onClose}, "Ok")
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/contacts/ContactGrabber/ComingSoonModal.js